import React, { useState } from 'react';
import { Container, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from './AuthContext';
import AuthModalHandler from './AuthModalHandler';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, login } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState('login');

  React.useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      setShowAuthModal(true);
    }
  }, [isLoading, isAuthenticated]);

  const handleLoginSuccess = (response) => {
    
    const loginData = response.data;
    let userData = null;
    
    if (loginData && loginData.user) {
      userData = loginData.user;
    } else if (response.user) {
      userData = response.user;
    } else {
      // Don't create fallback user data - let the login component handle it
      return;
    }
    
    // Include is_admin property from the response
    if (response.is_admin !== undefined && userData) {
      userData = { ...userData, is_admin: response.is_admin };
    }
    
    login(userData, loginData?.token || response.token);
    setShowAuthModal(false);
  };

  const handleSignUpSuccess = (response) => {
    setShowAuthModal(false)
  };

  const handleCloseAuthModal = () => {
    setShowAuthModal(false);
    if (!isAuthenticated) {
      setTimeout(() => {
        window.location.href = '/';
      }, 100);
    }
  };

  const handleShowLogin = () => {
    setAuthMode('login');
    setShowAuthModal(true);
  };

  const handleShowSignUp = () => {
    setAuthMode('signup');
    setShowAuthModal(true);
  };

  if (isLoading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
          <p className="mt-2">Checking authentication...</p>
        </div>
      </Container>
    );
  }

  if (isAuthenticated) {
    return children;
  }

  return (
    <>
      <Container className="mt-5">
        <Alert variant="warning" className="text-center">
          <Alert.Heading>Authentication Required</Alert.Heading>
          <p>
            You need to be logged in to access your workspace. Please log in or create an account to continue.
          </p>
          <hr />
          <div className="d-flex gap-2 justify-content-center">
            <button 
              className="btn btn-primary"
              onClick={handleShowLogin}
            >
              Login
            </button>
            <button 
              className="btn btn-outline-primary"
              onClick={handleShowSignUp}
            >
              Sign Up
            </button>
          </div>
        </Alert>
      </Container>

      <AuthModalHandler
        show={showAuthModal}
        handleClose={handleCloseAuthModal}
        initialMode={authMode}
        onLoginSuccess={handleLoginSuccess}
        onSignUpSuccess={handleSignUpSuccess}
      />
    </>
  );
};

export default ProtectedRoute;